import { render, staticRenderFns } from "./Multi_product_homepage.vue?vue&type=template&id=34c7d5d0&"
import script from "./Multi_product_homepage.vue?vue&type=script&lang=js&"
export * from "./Multi_product_homepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports